module.exports = __webpack_public_path__ + "static/media/zulekha-hospital-logo.74f185d7.png";